export const INIT_ARRTASKS = 'INITIALISE_ARRTASKS';
export const EDIT_TASK = 'EDIT_TASK';
export const REMOVE_TASK = 'REMOVE_TASK';
export const ADD_TASK = 'ADD_TASK';
export const SET_ERR = 'SET_ERR';